import { SearchInput, type SearchInputProps } from '@/components/Form';
import { useInstantSearchState } from '@/components/InstantSearch';

type Props = Omit<SearchInputProps, 'value' | 'onSearch' | 'width'>;

const InstantSearchInput = (props: Props) => {
  const { queryState, updateQueryState } = useInstantSearchState();

  const handleSearch = (search: string) => {
    updateQueryState({ search, page: 1 });
  };

  return <SearchInput {...props} value={queryState.search} onSearch={handleSearch} width={250} />;
};

export default InstantSearchInput;
